import "./index.css";
import { Controller, useFormContext } from "react-hook-form";
import Select from "../select";
import { FormSelect as FormSelectProps } from "./index.types";

export function FormSelect({
  name,
  isRequired,
  error,
  fieldsToReset,
  label,
  ...rest
}: FormSelectProps) {
  const { control, setValue, clearErrors, unregister, resetField } =
    useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      rules={{
        ...(isRequired
          ? {
              required: (error?.message as any) || "Field is required",
            }
          : {}),
      }}
      render={({ field: { onBlur, ...restField }, fieldState: { error } }) => {
        return (
          <Select
            isRequired
            label={label}
            error={{
              is: !!error,
              message: error?.message || "",
            }}
            setFormSelected={setValue}
            resetForm={() =>
              fieldsToReset &&
              fieldsToReset.map((field) => {
                setValue(field, undefined);
                unregister(field);
              })
            }
            clearError={clearErrors}
            onFormBlur={onBlur}
            {...restField}
            {...rest}
          />
        );
      }}
    />
  );
}

export default FormSelect;
